// src/components/NoItemsFound.tsx
import React from 'react';
import {
  Button,
  Flex,
  Heading,
  HStack,
  Text,
} from '@chakra-ui/react';
import { WarningTwoIcon } from '@chakra-ui/icons';
import { useReducedMotion } from 'framer-motion';
import { MotionBox } from '../motion/MotionComponents';

interface NoItemsFoundProps {
  mainMessage: string; // Main message as a heading
  detailMessage: string; // Detailed explanation message
  refetch?: () => void;
  removeFilters?: () => void;
}

const NoItemsFound: React.FC<NoItemsFoundProps> = ({
  mainMessage,
  detailMessage,
  refetch,
  removeFilters,
}) => {
  const prefersReducedMotion = useReducedMotion();

  return (
    <Flex ml="25vw">
      <MotionBox
        borderWidth="1px"
        borderRadius="lg"
        boxShadow="sm"
        p={[4, 6]}
        textAlign={'center'}
        bg="white"
        mx="2"
        maxW="md"
        initial={prefersReducedMotion ? { opacity: 1, y: 0 } : { opacity: 0, y: 6 }}
        animate={{ opacity: 1, y: 0 }}
      >
        <WarningTwoIcon boxSize={[8, 10]} color="orange.400" mb={4} />
        <Heading size="lg" mb={2} color={'gray.800'}>
          {mainMessage}
        </Heading>
        <Text mb={4} color={'gray.600'}>
          {detailMessage}
        </Text>
        <HStack gap="1rem" alignItems={'flex-start'} justifyContent={'center'}>
          {refetch && (
            <MotionBox
              whileHover={prefersReducedMotion ? undefined : { y: -1 }}
              whileTap={prefersReducedMotion ? undefined : { scale: 0.99 }}
            >
              <Button
                colorScheme="blue"
                variant={'outline'}
                onClick={refetch}
              >
                Refresh
              </Button>
            </MotionBox>
          )}
          {removeFilters && (
            <MotionBox
              whileHover={prefersReducedMotion ? undefined : { y: -1 }}
              whileTap={prefersReducedMotion ? undefined : { scale: 0.99 }}
            >
              <Button
                colorScheme="blue"
                onClick={removeFilters}
              >
                Remove Filters
              </Button>
            </MotionBox>
          )}
        </HStack>
      </MotionBox>
    </Flex>
  );
};

export default NoItemsFound;
